import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import NewsletterForm from './NewsletterForm';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="text-lg font-bold">双女主韩漫</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              专注双女主题材的韩漫在线阅读平台，收录最新最热门的双女主韩漫作品，提供清晰便捷的分类与搜索，让你轻松追漫、放心阅读。
            </p>
            <div className="mt-6 max-w-md">
              <p className="mb-2 text-sm font-semibold text-background-50">订阅更新提醒</p>
              <NewsletterForm />
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">
              <Link to="/#categories" className="transition-colors hover:text-primary-300">
                漫画分类
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-background-200">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="transition-colors hover:text-primary-300"
                  >
                    {category.name}双女主韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">关于与帮助</h4>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-background-200">
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-primary-300">
                  搜索漫画
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="transition-colors hover:text-primary-300">
                  热门恋爱韩漫
                </Link>
              </li>
              <li className="flex items-center gap-2 pt-2">
                <i className="ri-mail-line text-primary-300"></i>
                hello@shuangnuzhu-comic.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-300"></i>
                WeChat：shuangnuzhu_comic
              </li>
              <li className="flex items-center gap-3 pt-2 text-lg">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-800">
                  <i className="ri-weibo-line"></i>
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-800">
                  <i className="ri-twitter-x-line"></i>
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-800">
                  <i className="ri-instagram-line"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-accent-700/60 pt-6 text-xs text-background-200 sm:flex-row">
          <p>© {year} 韩漫免费观看在线阅读漫画双女主 · 本站内容为演示数据，仅供学习交流</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-300">
              用户协议
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-300">
              隐私政策
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-300">
              友情链接
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}